import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise, AxiosResponse } from 'axios';
import User from "@/models/User";
import store from "@/store";
import HomeFilter from "@/models/HomeFilter";
const rootPath = "Users";

class UserService {
  public getTableUrl(userProfil: string, lang: string): string {
    return `${apiClient.defaults.baseURL || ''}${rootPath}${buildQuery({ lang, userProfil })}`;
  }

  public forgotPassword(mail: string, lang: string): AxiosPromise {
    return apiClient.post(`${rootPath}/forgotPassword`, {
      mail: mail,
      lang: lang,
    });
  }

  public resetPassword(data: object): AxiosPromise {
    return apiClient.post(`${rootPath}/ResetPassword`, data);
  }

  public getUserShort(): string {
    var savedUser = localStorage.getItem("user");
    if (!savedUser) {
      return "";
    }
    let user = JSON.parse(savedUser);
    var result = user.firstName.charAt(0) + "." + user.lastName;
    return result.toString();
  }

  public getusersByRole(userRole: string, lang: string): AxiosPromise {
    return apiClient.get(`${rootPath}${buildQuery({ lang, userRole })}`);
  }

  public getContactUsersByEntreprise(
    entrepriseId: string,
    lang: string
  ): AxiosPromise {
    return apiClient.get(`${rootPath}/entrepriseUsers${buildQuery({
      lang,
      entrepriseId,
      isContact: true,
    })}`);
  }
  public getOrderGiverUsersBySite(siteId: string, lang: string): AxiosPromise {
    return apiClient.get(`${rootPath}/orderGiverUsers${buildQuery({ lang, siteId })}`);
  }
  public getCurrentuser(): User {
    var curretnUser: User = store.state.userModule.user; // localStorage.getItem('user');
    if (curretnUser === null) curretnUser = new User();

    return curretnUser;
  }
  public addUser(data: any, lang: string): AxiosPromise {
    return apiClient.put(`${rootPath}/${data.id}${buildQuery({ lang })}`, data);
  }

  public saveUsers(data: Array<any>, lang: string): AxiosPromise {
    return apiClient.post(`${rootPath}${buildQuery({ lang })}`, data);
  }

  public loginStore(data: any) {
    return apiClient.post<User>(`${rootPath}/authenticate`, data);
  }

  public getConnectedUser(bearer: any): AxiosPromise {
    var AuthStr = "Bearer " + bearer;
    return apiClient.get(`${rootPath}/getConnectedUser`, {
      headers: {
        Authorization: AuthStr,
        "Content-Type": "application/json",
      }
    });
  }

  public login(username: string, password: string) {
    const data = {
      Login: username,
      Password: password,
    };

    return apiClient
      .post<User>(`${rootPath}/authenticate`, data)
      .then(this.handleResponse)
      .catch((error) => {
        return Promise.reject(error);
      })
      .then((user: User) => {
        // login successful if there's a user in the response
        if (user) {
          // store user details and basic auth credentials in local storage
          // to keep user logged in between page refreshes
          // user.authdata = window.btoa(username + ':' + password);
          localStorage.setItem("user", JSON.stringify(user));
        }

        return user;
      });
  }

  async canApproveBop(bopId: string, userId: string): Promise<boolean> {
    try {
      const response = await apiClient.get(
        `${rootPath}/canApproveBop/${bopId}/${userId}`
      );
      return response.data.canApprove;
    } catch (error) {
      console.error("Error checking approval rights:", error);
      throw new Error(
        "Failed to check approval rights. Please try again later."
      );
    }
  }

  public refreshCurrentUser() {
    return apiClient.get(`${rootPath}/getCurrentUser`);
  }

  /**
   * Logs out the current user.
   * Server endpoint will invalidate token and either:
   *  - return JSON { logoutUrl } (preferred for SPA) when redirect query param omitted/false
   *  - or issue a 302 redirect if redirect=true or Accept header requests html
   * We always request JSON then perform a client-side navigation to avoid CORS issues.
   */
  public async logout(): Promise<void> {
    const user = this.getCurrentuser();
    if (!user || !user.id) {
      localStorage.removeItem("user");
      return;
    }
    try {
      if(user.authenticationToken){
        // Basic auth - no server side logout needed
        const response = await apiClient.post(
        `${rootPath}/logoutBasic/${user.id}`,
        null,
        {
          headers: { Accept: "application/json" },
        } as any
      );
        localStorage.removeItem("user");

        return;
      }
      const response = await apiClient.post(
        `${rootPath}/logoutSso/${user.id}?redirect=false`,
        null,
        {
          headers: { Accept: "application/json" },
        } as any
      );

      // Remove user locally AFTER server invalidation succeeds
      localStorage.removeItem("user");

      // If server says user already logged out just stop
      if (response?.data?.alreadyLoggedOut) {
        return;
      }

      // If we received a logoutUrl, perform navigation so Azure clears its cookies
      const logoutUrl = response?.data?.logoutUrl;
      if (logoutUrl && typeof window !== "undefined") {
        store.commit("logout");
        window.location.assign(logoutUrl);
      }
    } catch (err: any) {
      // On any failure, still remove user locally to force a clean state
      localStorage.removeItem("user");
      // Best effort: if server responded with a redirect we might detect it
      const attemptedUrl = (err?.response && err.response.request && err.response.request.responseURL) || "";
      if (attemptedUrl.includes("login.microsoftonline.com") && typeof window !== "undefined") {
        window.location.assign(attemptedUrl);
      } else {
        console.error("Logout failed", err);
      }
    }
  }

    public getUserPreferences(userId: string): AxiosPromise {
    return apiClient.get(`${rootPath}/getUserPreferences/${userId}`);
  }

    public setPreferences(userId: string, data: HomeFilter) : AxiosPromise{
    return apiClient.post(`${rootPath}/setUserPreferences/${userId}`, data);
  }


  handleResponse(response: AxiosResponse<User>) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      this.logout();
      location.reload();
      const error = response.statusText;
      return Promise.reject(error);
    }

    return response.data;
  }
}
export default new UserService();
